import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import {
	PACKAGE_NAME,
	TEAM_NAME,
} from '@atlassian/jira-atlassian-navigation-nav4-common/src/common/constants.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import getMeta from '@atlassian/jira-get-meta';
import type { AtlaskitAtlassianNavigationNav4Props } from './types.tsx';
import { AtlassianNavigationNav4 } from './AtlassianNavigationNav4.tsx';
import { AtlaskitAtlassianNavigationNav4 } from './atlaskit-atlassian-navigation-nav4/AtlaskitAtlassianNavigationNav4.tsx';

// TODO: Remove all AtlaskitAtlassianNavigationNav4 when cleaning up blu-7584-replace-nav4-profile-query
const TopNavComponent = componentWithCondition(
	() => fg('blu-7584-replace-nav4-profile-query'),
	AtlassianNavigationNav4,
	AtlaskitAtlassianNavigationNav4,
);

export function TopNav4(props: AtlaskitAtlassianNavigationNav4Props) {
	// This is defensive code to prevent making a request for data that will never be returned.
	// Only Customer Accounts have customer service access. These are non-Atlassian accounts considered
	// second-party party customers and should only have access to the JSM Help Center. They should
	// never have access to the regular Jira UI so should never see this top navigation. If we detect
	// that this is a customer account request we will not render the top navigation at all.
	// See https://jplat.atlassian.net/browse/BLU-7341 for context.
	if (fg('blu-7341-fix_top_nav_query_for_unauthorized_users')) {
		if (getMeta('ajs-account-type') === 'customer') {
			return null;
		}
	}

	return (
		<UFOSegment name="atlaskit-atlassian-navigation-nav4">
			<JSErrorBoundary
				id="AtlaskitAtlassianNavigationNav4"
				packageName={PACKAGE_NAME}
				teamName={TEAM_NAME}
				fallback="flag"
			>
				<TopNavComponent {...props} />
			</JSErrorBoundary>
		</UFOSegment>
	);
}
